module.exports = __webpack_public_path__ + "img/loading_.9432d43d.png";